import { useRouteMatch } from 'react-router-dom';
import type { ValueOf } from 'type-fest';

import { ORDER_STATUS } from '@frontend/api';

import { ordersBaseRoute } from 'modules/orders';

export const useActiveTab = () => {
  const childMatch = useRouteMatch<{ status: ValueOf<typeof ORDER_STATUS> }>(
    `${ordersBaseRoute}/:status`,
  );

  const activeTab = childMatch?.params.status ?? ORDER_STATUS.ALL;

  return activeTab;
};
